'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createIndustryRootsQueryOptions } from '@/modules/shared/contracts';
import type { IndustryRootsQueryOptions } from '@/modules/shared/contracts';

export const useIndustryRootsQuery = (options?: Partial<IndustryRootsQueryOptions>) => {
	const queryOptions = createIndustryRootsQueryOptions();

	return tsrShared.industries.listRoots.useQuery({
		...queryOptions,
		...options,
	});
};
